export const mobileBackground: any = {
    sync: 'htvSyncImageMobile',
    recalls: 'htvRecallsImageMobile',
    fordpass: 'htvFordPassImageMobile',
    warranty: 'htvWarrantyImageMobile',
    quicktips: 'htvQuickTipImageMobile',
    oilchange: 'htvOilChangeImageMobile',
    fordservices: 'htvFordPassImageMobile',
    keysandlocks: 'htvKeysAndLocksImageMobile',
    fordtechnology: 'htvFordTechnologyImageMobile',
    ownerresources: 'htvOwnerResourcesImageMobile',
    tiresandwheels: 'htvTiresAndWheelsImageMobile',
    electricvehicles: 'htvElectricVehiclesImageMobile',
    morevehicletopics: 'htvMoreVehicleTopicsImageMobile',
    lincolnservices: 'lincolnServicesImageMobile',
    lincolntechnology: 'lincolnTechnologyImageMobile',
    lincolnwayapp: 'lincolnWayAppImageMobile',
};
export const desktopBackground: any = {
    sync: 'htvSyncImageDesktop',
    recalls: 'htvRecallsImageDesktop',
    fordpass: 'htvFordPassImageDesktop',
    warranty: 'htvWarrantyImageDesktop',
    quicktips: 'htvQuickTipImageDesktop',
    oilchange: 'htvOilChangeImageDesktop',
    keysandlocks: 'htvKeysAndLocksImageDesktop',
    fordservices: 'htvFordServicesImageDesktop',
    fordtechnology: 'htvFordTechnologyImageDesktop',
    ownerresources: 'htvOwnerResourcesImageDesktop',
    tiresandwheels: 'htvTiresAndWheelsImageDesktop',
    electricvehicles: 'htvElectricVehiclesImageDesktop',
    morevehicletopics: 'htvMoreVehicleTopicsImageDesktop',
    lincolnservices: 'lincolnServicesImageDesktop',
    lincolntechnology: 'lincolnTechnologyImageDesktop',
    lincolnwayapp: 'lincolnWayAppImageDesktop',
};

export const QUICKTIP_DYF_TITLE = 'Discover Your Ford';
